import { useState, useEffect } from "react";

/*

wzorzec "singleton event listener"

DLACZEGO ZMIENNE SĄ GLOBALNE (NA ZEWNĄTRZ HOOKA):
- Każdy import hooka w komponencie tworzy NOWĄ INSTANCJĘ hooka
- Ale wszystkie instancje WSPÓŁDZIELĄ te same globalne zmienne
- Dzięki temu: 1 event listener obsługuje wszystkie komponenty
- Gdyby zmienne były wewnątrz: każda instancja = osobny event listener = performance problem

JAK TO DZIAŁA:
1. ComponentA importuje hook → tworzy instancję 1 → dodaje event listener + swój callback
2. ComponentB importuje hook → tworzy instancję 2 → używa istniejącego listenera + dodaje swój callback  
3. Resize → 1 listener wywołuje wszystkie callbacki → wszystkie komponenty się aktualizują

DLACZEGO LEPSZY NIŻ OSOBNE EVENT LISTENERY:
Ten hook eliminuje problem n-listenerów (gdzie każdy komponent dodaje własny) - zamiast 50 addEventListener przy 50 komponentach, mamy tylko 1.
*/

// Globalne zmienne - współdzielone między WSZYSTKIMI instancjami hooka
let callbacks = new Set(); // Zbiór funkcji callback do wywołania przy resize
let currentWidth =
	typeof window !== "undefined" ? document.documentElement.clientWidth : 0; // Rzeczywista szerokość widoczna (bez scrollbara)
let isInitialized = false; // Flaga czy event listener został już dodany

// Funkcja obsługująca resize - NA ZEWNĄTRZ hooka żeby nie tworzyć nowej funkcji przy każdym renderze każdej instancji
const handleResize = () => {
	currentWidth = document.documentElement.clientWidth; // Rzeczywista szerokość bez scrollbara

	callbacks.forEach((callback) => {
		// Wywołaj wszystkie zarejestrowane callbacki
		callback(currentWidth); // Przekaż nową szerokość do każdego callback
	});
};

// Hook - każdy import tworzy NOWĄ INSTANCJĘ, ale używa tych samych globalnych zmiennych
const useGlobalWindowWidth = () => {
	const [width, setWidth] = useState(() => currentWidth); // State z aktualną szerokością - LOKALNY dla tej instancji

	useEffect(() => {
		// Zainicjuj listener przy pierwszym subscribe
		if (!isInitialized && typeof window !== "undefined") {
			// Jeśli pierwszy raz i window istnieje
			window.addEventListener("resize", handleResize); // Dodaj globalny event listener
			isInitialized = true; // Oznacz jako zainicjowany
		}

		callbacks.add(setWidth); // Dodaj setWidth tego komponentu do callbacków
		setWidth(currentWidth); // Ustaw aktualną szerokość od razu

		// Cleanup
		return () => {
			callbacks.delete(setWidth); // Usuń setWidth przy unmount komponentu
		};
	}, []);

	return width; // Zwróć aktualną szerokość
};

export default useGlobalWindowWidth;
// UŻYCIE ->  const windowWidth = useGlobalWindowWidth();
